import React from 'react'

import type {Feature, LngLat, MapLocationRequest} from '../map'
import {lngLatsToBounds} from '../map'
import {Cluster} from './components/Cluster/Cluster'
import type {ClusterFeature, MapPoint} from './types'

const DEFAULT_BOUNDS = [
  [0, 0],
  [0, 0],
]

type SetLocationFn = (location: MapLocationRequest) => void

export const getCluster = (setLocation?: SetLocationFn) => (coord: LngLat, features: Feature[]) => {
  const clusterClickHandler = () => {
    if (!setLocation) {
      return
    }

    const coords = features.map(({geometry}) => geometry.coordinates)
    const bounds = lngLatsToBounds(coords, true)

    if (bounds) {
      setLocation({bounds, duration: 400})
    }
  }

  return <Cluster coordinates={coord} onClick={setLocation ? clusterClickHandler : undefined} value={features.length} />
}

export const mapPointToFeature = ({id, coordinates, ...props}: MapPoint): ClusterFeature => ({
  type: 'Feature',
  id,
  geometry: {coordinates, type: 'Point'},
  properties: props,
})

type GetLocationProps = {
  points?: MapPoint[]
  polygon?: LngLat[]
  point?: MapPoint
}

export const getLocation = ({point, points, polygon}: GetLocationProps) => {
  const initial = {zoom: 6, duration: 400}

  if (point) {
    return {
      zoom: 16,
      center: point.coordinates,
    }
  }

  if (points?.length === 1) {
    return {
      ...initial,
      center: points[0].coordinates,
      zoom: 7,
    }
  } else {
    return {
      ...initial,
      bounds: lngLatsToBounds(polygon || points?.map(({coordinates}) => coordinates) || [], true) || DEFAULT_BOUNDS,
    }
  }
}
